require('./mortgageBonuses.scss');

// @ vendors
import React from "react";
import PropTypes from "prop-types";

// @ constants
const {
    TAGGING_LABEL_EVENTS,
    FF_BONUSES,
    ACTION_EVENTS,
    BONUSES_KEY,
    BONUSES_SUB_SUBTYPE
} = require('constants/mortgageInsuranceBonuses');
const { PAGE_MORTGAGE_PANEL, MORTGAGE_INSURANCE_BONUS_CLICK } = require('constants/tagging');

// @ commons
const { OKLink } = require('commonsComponents/OKLink');

// @ helpers
const { FormattedText } = require('core/i18n').i18n;

// @components
const MortgageBonusesModal = require('./mortgageBonusesModal');

// @utilities
const { checkIfBudgetIsConfirmed } = require('utilities/mortgageHelper');
const { recordLinkV2 } = require("utilities/tagging");

class MortgageBonuses extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            bonusKey: '',
        }

        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleCancelLink = this.handleCancelLink.bind(this);
        this.recordTaggingEvent = this.recordTaggingEvent.bind(this);
        this.checkFFS = this.checkFFS.bind(this);
    }

    recordTaggingEvent(eventTag, isModal = false, eventAction = null) {
        const customData = ({
            categoriaEvento: isModal ? PAGE_MORTGAGE_PANEL : MORTGAGE_INSURANCE_BONUS_CLICK,
            accionEvento: eventAction || `${isModal ? 'modal ' : ''}${ACTION_EVENTS[this.state.bonusKey]}`,
            etiquetaEvento: eventTag,
            nombrePagina: PAGE_MORTGAGE_PANEL,
        });
        recordLinkV2(customData);
    }

    handleTagging() {
        const {
            MORE_INFORMATION,
            SHOW_MODAL,
        } = TAGGING_LABEL_EVENTS;

        if(this.state.showModal) {
            this.recordTaggingEvent(MORE_INFORMATION);
            this.recordTaggingEvent(SHOW_MODAL, true);
        }
    }

    handleCloseModal(isButton) {
        this.setState({
            showModal: false
        });

        const {
            CLOSE_MODAL_BUTTON,
            CLOSE_MODAL_ICON,
        } = TAGGING_LABEL_EVENTS;

        const eventTag  = isButton ?
            CLOSE_MODAL_BUTTON : CLOSE_MODAL_ICON;
        this.recordTaggingEvent(eventTag, true);
    }

    handleToggleModal(key) {
        const { onHandleHasNotInsuranceClick, hasInsurance } = this.props;
        const isHomeInsurance = key === BONUSES_KEY.homeInsurance;

        if (!isHomeInsurance){
            this.setState({
                showModal: true,
                bonusKey: key
            }, this.handleTagging);

        } else {
            if (!hasInsurance) {
                onHandleHasNotInsuranceClick();
            } else {
                this.recordTaggingEvent(
                    TAGGING_LABEL_EVENTS.HOME_INSURANCE,
                    false,
                    ACTION_EVENTS[BONUSES_KEY.homeInsurance]
                );
            }
        }
    }

    checkFFS() {
        const {
            subTypeDocument
        } = this.props;
       let subtypeArray=[];
       switch (subTypeDocument) {
            case "008":
                subtypeArray=BONUSES_SUB_SUBTYPE.subTypeEightArray
                break;
            
            case "007":
                subtypeArray=BONUSES_SUB_SUBTYPE.subTypeSevenArray
                break;

            case "005":
                subtypeArray=BONUSES_SUB_SUBTYPE.subTypeFiveArray
                break;

            case "000":
                subtypeArray=BONUSES_SUB_SUBTYPE.subTypeZeroArray
                break;

            case null:
                subtypeArray=BONUSES_SUB_SUBTYPE.subTypeZeroArray
                break;
        }

        return Object.keys(FF_BONUSES).map((bonus) => {
            if (subtypeArray.indexOf(FF_BONUSES[bonus]) > -1) {
                return this.buildBonifications(FF_BONUSES[bonus])   
            }
            return null
        })
    }

    createPanelPoeditorKey(term) {
        const poeditorContext = 'mortgageRequestPanel';
        return `${poeditorContext}-${poeditorContext}_${term}`;
    }

    handleCancelLink() {
        const { onHandleToggleInsuranceCancelModal } = this.props;
        this.recordTaggingEvent(
            TAGGING_LABEL_EVENTS.CANCEL_BUTTON,
            false,
            ACTION_EVENTS[BONUSES_KEY.homeInsurance]
        );
        onHandleToggleInsuranceCancelModal();
    }

    buildCancelInsuranceButton() {
        const {
            hasInsurance,
            mortgageCancelOption
        } = this.props;
        
        if(mortgageCancelOption && hasInsurance) {
            return (
                <div className="mortgage-insurance-bonuses__insurance-cancel">
                    <OKLink
                        onClick={this.handleCancelLink}
                        modifier="dark"
                    >
                        <FormattedText value={this.createPanelPoeditorKey('cancelInsuranceButtonBonuses')} />
                    </OKLink>
                </div>
            )
        }

        return null;
    }

    getHomeInsuranceButtonKeyText() {
        const { insuranceState, mortgageInsuranceState, hasInsurance } = this.props;
        const budgetConfirmed = checkIfBudgetIsConfirmed(insuranceState);
        const isInsuranceConfirmed = mortgageInsuranceState.getIn(['insurancesRelatedStatusData', 'closedPrice']);
        let key = 'quote';

        if(!hasInsurance) {
            return 'moreInformationButtonBonuses';
        } else if(isInsuranceConfirmed) {
            key = 'get';
        } else if (budgetConfirmed) {
            key = 'finish';
        } else if (insuranceState) {
            key = 'modify';
        }

        return `${key}InsuranceButtonBonuses`;
    }

    buildBonifications(key) {
        const {
            hasInsurance,
            accountHolder,
            isInsuranceRestricted,
            disclaimerMessage,
        } = this.props;
        const isHomeInsurance = key === BONUSES_KEY.homeInsurance;
        const simulationDisabled = (isInsuranceRestricted && !hasInsurance) || accountHolder !== 1;
        const buttonKey = isHomeInsurance ? this.getHomeInsuranceButtonKeyText() : 'moreInformationButtonBonuses';
        const cancelInsuranceButton = isHomeInsurance ? this.buildCancelInsuranceButton() : null;
        return (
            <li key={`mortgage-insurance-bonuses-${key}`}>
                <div className="row mortgage-insurance-bonuses">
                    <div className="col-md-7">
                        <div className="mortgage-insurance-bonuses__title">
                            <FormattedText value={this.createPanelPoeditorKey(`${key}BonusesTitle`)} />
                            
                        </div>
                        <div className="mortgage-insurance-bonuses__description">
                            <FormattedText value={this.createPanelPoeditorKey(`${key}BonusesDescription`)} />
                        </div>
                        {isHomeInsurance ?
                            <div className="mortgage-insurance-bonuses__note">
                                <FormattedText value={this.createPanelPoeditorKey(`${key}BonusesNote`)} />
                            </div> : null
                        }
                    </div>
                    {(isHomeInsurance && !simulationDisabled) || !isHomeInsurance ?
                        <div className="col-md-5 mortgage-insurance-bonuses__right-section" >
                            <OKLink
                                to={isHomeInsurance && '/myprofile/mortgage/insurances-related'}
                                onClick={() => this.handleToggleModal(key)}
                                extraClass="mortgage-insurance-bonuses__more-info"
                                modifier="emphasize"
                            >
                                <FormattedText value={this.createPanelPoeditorKey(buttonKey)} />
                                <i
                                    className="icon-breadcrumb mortgage-insurance-bonuses__icon-more-info"
                                />
                            </OKLink>
                            {cancelInsuranceButton}
                        </div> : null
                    }
                    {isHomeInsurance ?
                        <div className="col-xs-12 mortgage-insurance-bonuses__informative-message">
                            {disclaimerMessage}
                        </div> : null
                    }
                </div>
            </li>
        )
    }

    render() {
        const { showModal, bonusKey } = this.state;
        return (
            <React.Fragment>
                {this.checkFFS()}
                <MortgageBonusesModal
                    showModal={showModal}
                    bonusKey={bonusKey}
                    recordTaggingEvent={this.recordTaggingEvent}
                    onCloseCallback={this.handleCloseModal}
                />
            </React.Fragment>
        )
    }
}

MortgageBonuses.propTypes = {
    hasInsurance: PropTypes.bool.isRequired,
    onHandleHasNotInsuranceClick: PropTypes.func.isRequired,
    insuranceState: PropTypes.object.isRequired,
    accountHolder: PropTypes.string.isRequired,
    mortgageInsuranceState: PropTypes.object.isRequired,
    isInsuranceRestricted: PropTypes.bool.isRequired,
    mortgageCancelOption: PropTypes.bool.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    disclaimerMessage: PropTypes.node.isRequired,
    onHandleToggleInsuranceCancelModal: PropTypes.func.isRequired,
    subTypeDocument:PropTypes.string.isRequired
}

module.exports = MortgageBonuses;
